import {SECCIONES} from "../Constantes";
import {scrolearAComponente} from "./scrolearAComponente";
import {useNavigate} from "react-router-dom";

export const useIrRuta = () => {
    const navigate = useNavigate()

    const ir = (secc) => {

        switch (secc) {
            case SECCIONES[1]:
                navigate('/Locales');
                break
            case SECCIONES[0]:
                navigate('/Home')
                setTimeout(() => {
                    scrolearAComponente('catalogo')
                }, 500)
                break
            case SECCIONES[2]:
                navigate('/PorMayor')
                break
            case SECCIONES[3]:
                navigate('/Nosotros')
                break
        }
    }

    return {
        ir
    }


}